import { StyleSheet } from 'react-native';
import theme from '@/constants/colors';
import { Typography } from '@/constants/typography';

export default StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.backgroundPrimary,
  },
  content: {
    padding: 16,
    paddingBottom: 40,
  },
  summaryCard: {
    backgroundColor: theme.backgroundSecondary,
    borderRadius: 14,
    padding: 18,
    marginBottom: 16,
  },
  summaryIconRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    marginBottom: 10,
  },
  summaryTitle: {
    ...Typography.h2(theme.accentPrimary),
  },
  summaryBody: {
    ...Typography.body(theme.textPrimary),
    lineHeight: 20,
    marginBottom: 12,
    opacity: 0.85,
  },
  summaryCount: {
    backgroundColor: theme.backgroundPrimary,
    borderRadius: 8,
    paddingVertical: 8,
    paddingHorizontal: 14,
    alignSelf: 'flex-start',
  },
  summaryCountText: {
    ...Typography.label(theme.accentPrimary),
  },
  permCard: {
    backgroundColor: theme.backgroundSecondary,
    borderRadius: 14,
    padding: 16,
    marginBottom: 12,
  },
  permRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  permIconContainer: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: theme.backgroundPrimary,
    justifyContent: 'center',
    alignItems: 'center',
  },
  permInfo: {
    flex: 1,
    gap: 2,
  },
  permLabel: {
    ...Typography.label(theme.accentPrimary),
  },
  permDescription: {
    ...Typography.caption(theme.textMuted),
    lineHeight: 16,
  },
  permStatusContainer: {
    alignItems: 'center',
  },
  statusBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 12,
  },
  statusGranted: {
    backgroundColor: 'rgba(52, 199, 89, 0.12)',
  },
  statusGrantedText: {
    ...Typography.caption('#34C759'),
    fontWeight: '600',
  },
  statusDenied: {
    backgroundColor: 'rgba(255, 59, 48, 0.12)',
  },
  statusDeniedText: {
    ...Typography.caption('#FF3B30'),
    fontWeight: '600',
  },
  statusUnknown: {
    backgroundColor: 'rgba(160, 168, 131, 0.12)',
  },
  statusUnknownText: {
    ...Typography.caption(theme.textMuted),
  },
  enableButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.accentPrimary,
    borderRadius: 10,
    paddingVertical: 10,
    paddingHorizontal: 16,
    marginTop: 12,
    gap: 4,
  },
  enableButtonText: {
    ...Typography.label(theme.backgroundPrimary),
  },
  systemSettingsButton: {
    backgroundColor: theme.backgroundSecondary,
    borderRadius: 12,
    paddingVertical: 14,
    paddingHorizontal: 20,
    marginTop: 8,
    marginBottom: 12,
    alignItems: 'center',
  },
  systemSettingsButtonText: {
    ...Typography.label(theme.accentPrimary),
  },
  noteText: {
    ...Typography.caption(theme.textMuted),
    textAlign: 'center',
    lineHeight: 18,
    paddingHorizontal: 8,
  },
});